export default __webpack_public_path__ + "static/challenge-b4cfced0e70e7e1dbc8ea98e2267033f.png";